
const SHOW_MODAL = 'SHOW_MODAL';
const HIDE_MODAL = 'HIDE_MODAL';

export function openModal(modalOptions) {
  return dispatch => {
    dispatch({
      type: SHOW_MODAL,
      modalType: modalOptions.modalType,
      modalProps: modalOptions.modalProps
    });
  };
}


export function hideModal() {
  return dispatch => {
    dispatch({
      type: HIDE_MODAL
    });
  };
}


export const tryHideModal = () => (dispatch, getState) => {
  const state = getState();

  if (state.modal && state.modal.modalProps && !state.modal.modalProps.unclosable) {
    dispatch(hideModal());
  }
};


const initialState = {
  modalType: null,
  modalProps: {}
};
const modalReducer = (state = initialState, action) => {
  switch (action.type) {
  case SHOW_MODAL: {
    return {
      modalType: action.modalType,
      modalProps: action.modalProps
    };
  }
  case HIDE_MODAL: {
    return initialState;
  }
  default: {
    return state;
  }
  }
};

export function isMenuOpened(state) {
  return state.menu.isMenuOpened;
}

export function isModalOpened(state) {
  return state.modal.modalType != null;
}

export function getModalName(state) {
  return state.modal.modalType;
}

export default modalReducer;



// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js